import React from "react";

interface ISectionPageContext {
  textSectionContainerMaxWidthOverride?: string;
  textSectionContainerMaxWidthOverrideMobile?: string;
  sectionImageWidthOverride?: string;
  sectionImageBorderRadiusOverride?: string;
  isArticle?: boolean;
}
const SectionPageContext = React.createContext<ISectionPageContext>({});

export default SectionPageContext;
